import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
  type Timestamp,
} from 'firebase/firestore';
import { requestsPath, type ServiceRequestDoc } from '@hotel-voice/shared';
import { firestore } from './app';
import type { GuestRequest } from '@/types';

/**
 * Live subscription to the guest's own requests, newest first.
 *
 * This is the one thing the guest reads from Firestore directly: the rules
 * allow a request to be read by the guest who filed it, and a status moving
 * from REQUESTED to ACCEPTED is exactly the kind of change that should reach
 * the phone without a refresh. Writes still go through the callables.
 */
export function watchMyRequests(
  hotelId: string,
  guestUid: string,
  onChange: (requests: GuestRequest[]) => void,
  onError: (error: Error) => void,
): () => void {
  const q = query(
    collection(firestore(), requestsPath(hotelId)),
    where('guestUid', '==', guestUid),
    orderBy('createdAt', 'desc'),
  );

  return onSnapshot(
    q,
    (snapshot) => {
      onChange(
        snapshot.docs.map((doc) => {
          const data = doc.data() as ServiceRequestDoc;
          return {
            ...data,
            id: doc.id,
            createdAt: (data.createdAt as Timestamp | undefined) ?? null,
            updatedAt: (data.updatedAt as Timestamp | undefined) ?? null,
            acceptedAt: (data.acceptedAt as Timestamp | undefined) ?? null,
            completedAt: (data.completedAt as Timestamp | undefined) ?? null,
          };
        }),
      );
    },
    onError,
  );
}
